import { render, staticRenderFns } from "./PaymentResultCard.vue?vue&type=template&id=4a38065a&"
import script from "./PaymentResultCard.vue?vue&type=script&lang=js&"
export * from "./PaymentResultCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports